const Heading = {
  baseStyle: {
    fontWeight: "light"
  }
};

export default Heading;